import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { deepMerge } from '../../utils/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPre = styled.pre.withConfig({
  displayName: "Pre__StyledPre",
  componentId: "vsv38s-0"
})(({
  $use,
  $cssStyles,
  theme
}) => {
  return Object.assign({}, deepMerge(Object.assign({}, $use === 'code' && {
    color: theme.color['text-primary-default'],
    fontFamily: theme.typography['code-100'].fontFamily,
    fontWeight: theme.typography['code-100'].fontWeight,
    backgroundColor: theme.color['fill-surface-raised'],
    border: theme.space[0]
  }), $cssStyles));
});
export const Pre = _ref => {
  let {
      use = 'default',
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledPre, Object.assign({}, domProps, {
    $use: use,
    $cssStyles: cssStyles,
    children: children
  }));
};